























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import {
  AccomodationUnitStatusEnum,
  DashboardPeriodEnum,
} from "@/shared/models/enums.type";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { DateTime } from "luxon";
import { MaintenanceTaskViewModel } from "./types";
import { AccomodationUnitStatus } from "@/shared/models/accomodationUnitStatus";
import { MaintenanceTeamMember } from "../calendar/CalendarTypes";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { RolesEnum, userHasAnyRole } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import MaintenanceGridTile from "./MaintenanceGridTile.vue";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
import MobileFilterModal from "@/components/misc/MobileFilterModal.vue";
import GlobalFilterSensitiveMixin from "@/mixins/GlobalFilterSensitiveMixin";
import NoData from "@/components/misc/NoData.vue";

@Component({
  components: {
    MaintenanceGridTile,
    ScrollLoader,
    MobileFilterModal,
    NoData,
  },
  mixins: [GlobalFilterSensitiveMixin],
})
export default class MaintenanceGrid extends Vue {
  @Getter("codebooks/accomodationUnitStatuses")
  accomodationUnitStatuses?: AccomodationUnitStatus[];
  @Action("codebooks/refreshAccomodationUnitStatuses")
  refreshAccomodationUnitStatuses?: () => Promise<void>;

  @Getter("maintenance/maintenanceTeam")
  maintenanceTeam?: MaintenanceTeamMember[];
  @Action("maintenance/refreshMaintenanceTeam")
  refreshMaintenanceTeam?: () => Promise<void>;

  @Getter("calendar/currentDay") currentDay?: DateTime;
  @Watch("currentDay", { immediate: true })
  currentDayWatch() {
    this.filters.date = this.currentDay?.toISODate() ?? "";
  }

  get title() {
    switch (this.filters.source) {
      case "arrivals":
        return this.$t("Dashboard.MaintenanceArrivals");
      case "departures":
        return this.$t("Dashboard.MaintenanceDepartures");
      default:
        return this.$t("Dashboard.MaintenanceGeneral");
    }
  }

  @Getter("auth/claims") claims?: JwtClaims;
  get userIsMaintenanceTeamLeader() {
    return userHasAnyRole([RolesEnum.MaintenanceTeamLeader])(this.claims);
  }
  get maintenanceTeamMembers() {
    if (this.userIsMaintenanceTeamLeader) return this.maintenanceTeam ?? [];
    return (
      this.maintenanceTeam?.filter(
        (x) => x.tenantUserId.toString() == this.claims?.utid
      ) ?? []
    );
  }

  scrollEl = null as HTMLElement | null;
  items: MaintenanceTaskViewModel[] = [];
  loading = false;
  isDone = false;
  isInitialLoadDone = false;

  editingItem: MaintenanceTaskViewModel | null = null;
  editingModalOpen = false;
  submitting = false;

  @Watch("editingItem.statusId")
  editingItemStatusWatch(fresh: number, old: number) {
    if (
      this.editingItem &&
      this.claims?.utid &&
      !this.userIsMaintenanceTeamLeader &&
      (fresh === AccomodationUnitStatusEnum.CleaningInProgress ||
        fresh === AccomodationUnitStatusEnum.RepairInProgress) &&
      old != undefined
    ) {
      this.editingItem.maintenanceAssignedToTenantUserId = Number.parseInt(
        this.claims.utid
      );
    }
  }

  closeEditModal() {
    this.editingModalOpen = false;
    this.editingItem = null;
  }

  saveChanges() {
    if (!this.editingItem) {
      this.editingModalOpen = false;
      return;
    }

    this.submitting = true;
    this.axios
      .put("/maintenance/AccomodationUnitStatusUpdate", {
        id: this.editingItem.accomodationUnitId,
        reservationAccUnitTypeId: this.editingItem.reservationAccUnitTypeId,
        statusId: this.editingItem.statusId,
        maintenanceAssignedToTenantUserId:
          this.editingItem.maintenanceAssignedToTenantUserId,
        calendarUnitRemark: this.editingItem.calendarUnitRemark,
        reservationUnitRemark: this.editingItem.reservationUnitRemark,
        reservationRemark: this.editingItem.reservationRemark,
      })
      .then(() => {
        const editedItem = this.items.find(
          (x) => x.accomodationUnitId == this.editingItem?.accomodationUnitId
        );
        if (editedItem && this.editingItem) {
          editedItem.statusId = this.editingItem.statusId;
          editedItem.maintenanceAssignedToTenantUserId =
            this.editingItem.maintenanceAssignedToTenantUserId;
          editedItem.calendarUnitRemark = this.editingItem.calendarUnitRemark;
          editedItem.reservationUnitRemark =
            this.editingItem.reservationUnitRemark;
          editedItem.reservationRemark = this.editingItem.reservationRemark;
        }

        this.closeEditModal();
      })
      .finally(() => (this.submitting = false));
  }

  options: DataOptions = {
    page: 0,
    itemsPerPage: 25,
    sortBy: ["sortOrderHasValue", "sortOrder", "unitName"],
    sortDesc: [false, false, false],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  filterModalOpen = false;
  filters = {
    source: "general",
    filter: DashboardPeriodEnum.OnDate,
    date: "",
    propertyName: "",
    statusId: null as null | number,
  };
  @Watch("filters", { deep: true })
  filtersWatch() {
    this.refresh();
  }

  updateFilter(filters: any) {
    let filtersNotChanged = false;
    if (
      this.filters.propertyName === filters.nameFilter &&
      this.filters.statusId === filters.statusId
    ) {
      filtersNotChanged = true;
    }

    this.filters.propertyName = filters.nameFilter;
    this.filters.statusId = filters.statusId;

    this.options.sortBy = (filters.sortBy as string).split(";");
    this.options.sortDesc = [filters.sortDesc];

    while (this.options.sortDesc.length < this.options.sortBy.length) {
      this.options.sortDesc.push(this.options.sortDesc[0]);
    }

    if (filtersNotChanged) {
      this.refresh();
    }
  }

  refresh() {
    this.items = [];
    this.isDone = false;
    this.isInitialLoadDone = false;
    this.loadMore();
  }

  get sortOptions() {
    const options = [
      {
        text: this.$t("Property"),
        value: "sortOrderHasValue;sortOrder;unitName",
      },
    ];

    if (this.filters.source === "arrivals")
      options.push({
        text: this.$t("ExpectedArrivalTime"),
        value: "checkInTimeFrom",
      });

    if (this.filters.source === "departures")
      options.push({
        text: this.$t("ExpectedDepartureTime"),
        value: "checkOutTimeUntil",
      });

    return options;
  }

  @Watch("sensitiveKey")
  sensitiveKeyChanged(fresh: string, old: string) {
    if (fresh !== old) {
      this.refresh();
    }
  }

  get sortPrefil() {
    return {
      sortBy: this.options.sortBy.join(";"),
      desc: this.options.sortDesc[0],
    };
  }

  created() {
    if (
      (this.accomodationUnitStatuses?.length ?? 0) === 0 &&
      this.refreshAccomodationUnitStatuses
    ) {
      this.refreshAccomodationUnitStatuses();
    }

    if (
      (this.maintenanceTeam?.length ?? 0) === 0 &&
      this.refreshMaintenanceTeam
    ) {
      this.refreshMaintenanceTeam();
    }
  }

  mounted() {
    this.scrollEl = (this.$refs["scrollEl"] as HTMLElement) ?? null;

    const queryParams = this.$router.currentRoute.query ?? {
      source: "general",
    };

    this.filters.source =
      typeof queryParams.source === "string" ? queryParams.source : "general";

    this.loadMore();
  }

  async loadMore() {
    if (!this.loading && !this.isDone) {
      this.loading = true;
      const res = await this.load();
      this.items.splice(this.items.length, 0, ...(res.result || []));

      this.isInitialLoadDone = true;
      this.loading = false;
    }
  }

  async load() {
    const res = await this.axios
      .get<ListModel<MaintenanceTaskViewModel>>(
        "/maintenance/GetMaintenanceTasks",
        {
          params: {
            ...this.queryParams,
          },
        }
      )
      .then((res) => {
        return res.data;
      });

    if (res.result.length < this.options.itemsPerPage) {
      this.isDone = true;
    }

    return res;
  }

  get queryParams() {
    return {
      $skip: this.items.length,
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: false,
      ...this.filters,
    };
  }
}
